import { fetchGraphQL } from 'core/services/graphQLservice'


export async function getMoveDetailsByCustomer(CID: string) {

  var params = `query {
      getMoveAndReviewDetailsByCustomer(customerID:"${CID}")
        {
          customerID
          customerName
          moveID
          movingDate
          numberofMen
          numberOfTrucks
          totalRooms
          estimatedSqFt
          moveType
          moveSize
          fromZip
          toZip
          origin
          des
          branch
          moveRating
          distance
          reviewComment
        }
      }`;

  var response = await fetchGraphQL('POST', params);
  return response.data.getMoveAndReviewDetailsByCustomer;
}


/* export async function getCustomerDetails(CID: string) {

  var params = `query {
    getCustomerDetails(customerID:"${CID}")
      {
        customerID
    customerName
    customerDetails
    estimatorDetails
    branchDetails
    origin
    destination
    customerEmail
    customerAdd1
    customerAdd2
    customerDestAdd1
    customerDestAdd2
    customerPh
      }
    }`;

  var response = await fetchGraphQL('POST', params);
  return response.data.getCustomerDetails;
} */


export async function getEstFlowEstimateDetails(CID: string) {

  var params = `query {
    getEstFlowEstimateDetails(customerID:"${CID}")
      {
        junkServiceCharge
        customerID
     moveID
    customer
    email
    phone
    origin
    des
    loadCrewSize
    unLoadCrewSize
    loadRate
    unloadRate
    loadTrucks
    loadEstimatedHours
    unloadEstimatedHours
    travelHours
    travelRate
    packingCrew
    packingEstimateTime
    packingEstHrs
    fuelCharge
    packingCost
    materialCost
    totalCharges
    planType
    optionType
    moveDate
    estimatetype
    moveSizeDetail
    additionalCharges
    protectionCharges
    planTypeDesc
    discountValue
    totalChargesAfterDisc
    abfVal
    thirdPartyService
    salesTaxCost
    storageCharge
    isDisplayFVP
      }
    }`;

  var response = await fetchGraphQL('POST', params);
  return response.data.getEstFlowEstimateDetails;
}

export async function getEstimatorInventory(CID: string) {

  var params = `query {
    getEstimatorInventory(customerID:"${CID}")
      {
        customerID
    itemTypeID
    name
    materialID
    materialDescription
    qTY
    packingType
	cubeQTY
      }
    }`;

  var response = await fetchGraphQL('POST', params);
  return response.data.getEstimatorInventory;
}